import type { AuthContextType } from '@context/auth.context';
import type { Role } from '@interfaces/role';
import type { LoaderFunction } from 'react-router-dom';
import { redirect } from 'react-router-dom';

export const createAuthorizedLoader = (
  requiredRoles: Role[],
  auth: AuthContextType,
  loaderFunction: (auth: AuthContextType) => LoaderFunction,
) => {
  const hasRole = auth.hasRole;
  const loader = loaderFunction(auth);

  return (async (args) => {
    const isAuthorized = requiredRoles.some((role) => hasRole(role));
    if (!isAuthorized) {
      return redirect('/');
    }

    return await loader(args);
  }) satisfies LoaderFunction;
};
